/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function GenerateIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "generate", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M9 5.30423C6.33576 6.60253 4.5 9.33688 4.5 12.5C4.5 16.9183 8.08172 20.5 12.5 20.5C16.9183 20.5 20.5 16.9183 20.5 12.5C20.5 8.08172 16.9183 4.5 12.5 4.5V14.5M12.5 14.5L16 11M12.5 14.5L9 11", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(GenerateIcon);
export default ForwardRef;
//# sourceMappingURL=generateIcon.js.map